import axios, { AxiosRequestConfig } from "axios";
import { v1 as uuidv1 } from "uuid";

type ErrorResponse<E> = {
  apiVersion: string;
  error: E;
};

type SuccessResponse<D> = {
  apiVersion: string;
  data: D;
};

export const makeTintingRequest = async <R, E = never>(
  config: AxiosRequestConfig
): Promise<E | R> => {
  try {
    const xReqId = uuidv1();

    const response = (
      await axios.request<SuccessResponse<R> | ErrorResponse<E>>({
        ...config,
        headers: {
          "x-request-id": xReqId,
          ...config.headers,
        },
      })
    ).data;

    if ("error" in response) {
      return response.error;
    } else {
      return response.data;
    }
  } catch (error) {
    return Promise.reject(error);
  }
};
